import React from "react";
import { Route, Redirect } from "react-router-dom";

export const ProtectedRoute = ({
  component: Component,
  ...rest
}) => {
  const auth = rest.isLoggedIn;
  console.log(auth);
  const token = localStorage.getItem('ACCESS_TOKEN');
  return (
    <Route
      {...rest}
      render={props => {
        if (token!=='' && token!==null & token!==undefined) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: "/",
                state: {
                  from: props.location
                }
              }}
            />
          );
        }
      }}
    />
  );
};
